/** Shown when signup or OAuth cannot create a profile because the email is already registered. */
export const DUPLICATE_EMAIL_MESSAGE =
  'An account with this email address already exists. Please log in with your existing account. If you use email and password, you can reset it below.';

export class DuplicateEmailError extends Error {
  constructor() {
    super(DUPLICATE_EMAIL_MESSAGE);
    this.name = 'DuplicateEmailError';
  }
}

export function isDuplicateEmailError(err: unknown): boolean {
  return err instanceof DuplicateEmailError;
}
